import * as React from "react";
import Grid from "@mui/material/Grid";
import {
  CmpStatusIcon,
  CmpStatusIconV1,
  CmpTypographyField,
} from "../../../Component/Common/ToolBox/ToolBox";
import moment from "moment";
import { Typography } from "@mui/material";
import { Button } from "react-bootstrap";
import { CmpBtnCard } from "../../../Component/Common/ToolBox/ToolBoxV1";
export const CardSummary = ({ data = [], onClick = () => {} }) => {
  return (
    <Grid container spacing={2} className="mt-1">
      {data?.map((item, index) => (
        <Grid
          item
          xs={12}
          sm={12}
          md={6}
          lg={4}
          key={index}
          onClick={() => {
            let items = { row: item };
            onClick(items);
          }}
        >
          <Grid
            container
            spacing={0}
            rowSpacing={1}
            // sx={{
            //   borderWidth: "1px 1px 1px 5px",
            //   borderStyle: "solid solid solid solid",
            //   borderRadius: "10px 10px 10px 10px",
            //   padding: "12px 8px",
            //   marginTop: "5px",
            //   borderColor: "#0d73bb",
            //   border: " 1px solid lightgray",
            //   boxShadow:
            //     "1px 3px 7px 1px rgb(130 132 139 / 53%), 0 2px 10px 0 rgb(24 78 227 / 28%)",
            // }}
            columns={{ xs: 12, sm: 12, md: 12 }}
            className="CardBorderDesign"
          >
            <Grid item xs={3} sm={3} md={3}>
              <Typography
                className=" CardFontStyleLabel CardFontStyle txt-overflow-ellipse"
                component={"span"}
              >
                Version
              </Typography>
            </Grid>

            <Grid item xs={3} sm={3} md={3}>
              <Typography
                className=" CardFontStyleValue CardFontStyle txt-overflow-ellipse"
                component={"span"}
              >
                {item?.VS_Version}
              </Typography>
            </Grid>

            <Grid item xs={2} sm={2} md={2}>
              <Typography
                className=" CardFontStyleLabel CardFontStyle txt-overflow-ellipse"
                component={"span"}
              >
                Date
              </Typography>
            </Grid>

            <Grid item  xs={2} sm={2}  md={2}>
              <Typography
                className=" CardFontStyleLabel CardFontStyle txt-overflow-ellipse"
                component={"span"}
              >
                {moment(item?.VS_PostDt).format("DD/MM/YYYY") ||""}
              </Typography>
            </Grid>

            <Grid item xs={2} sm={2}  textAlign={"end"}>
              <CmpStatusIconV1 xStatus={item?.VS_Status} />
            </Grid>
            
            <Grid item xs={3} sm={2}  md={3} lg={4}>
              <Typography
                className="CardFontStyleLabel CardFontStyle txt-overflow-ellipse"
                component={"span"}
              >
                 User
              </Typography>
            </Grid>

            <Grid item xs={4} sm={4}  md={4} lg={4}>
              <Typography
                className=" CardFontStyleValue CardFontStyle txt-overflow-ellipse"
                component={"span"}
              >
                {item?.Username}
              </Typography>
            </Grid>
              
          </Grid>
        </Grid>
      ))}
    </Grid>
  );
};
